// Dependencies
import styled, { keyframes } from 'styled-components'

// Types
import { CarouselSlideDirections } from './carousel.types'

const slideInFromRight = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

export const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  gap: 24px;

  z-index: 2;
`

export const CarouselLeftIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background-color: #fff;
  border-radius: 16px 0 0 16px;
  cursor: pointer;
`

export const CarouselRightIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background-color: #fff;
  border-radius: 0 16px 16px 0;
  cursor: pointer;
`

// Types
export type CarouselContentStyleProps = {
  slideDirection: CarouselSlideDirections
  isActive: boolean
}

export const CarouselContent = styled.div<CarouselContentStyleProps>`
  position: relative;

  display: ${({ isActive }) => (!!isActive ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  animation: ${({ slideDirection }) =>
      slideDirection === 'right' ? slideInFromRight : slideInFromLeft}
    0.5s ease;
`

export const CarouselIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const CarouselSliderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CaroulselIcon = styled.img`
  display: block;
`
